var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 810 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0v1h.5z",
    transform: "rotate(18 3.157 -.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "scale(-1 1)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    transform: "matrix(30 0 0 30 405 270)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    y: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    y: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-144 -2.344 -2.11)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(144 -2.11 -2.344)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(72 -4.663 -2.076)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(72 -5.076 .534)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "scale(-1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.395d0fb2846649e71fecd5cc06351102.svg";
export { ForwardRef as ReactComponent };